import { AxiosError } from 'axios';
import { FC, PropsWithChildren, useState } from 'react';
import { useNotification } from '../../Contexts/NotificationContext';
import { performEnterpriseGPTApiCall, useEnterpriseGPTApiCall } from '../../Hooks/useMiddlewareApiCall';
import EnrollmentDialog from './EnrollmentDialog';

type EnrollementState = 'unknown' | 'enrolled' | 'not-enrolled';

const EnrollmentChecker: FC<PropsWithChildren> = (props: PropsWithChildren) => {
    const { children } = props;
    const [enrollementState, setEnrollementState] = useState<EnrollementState>('unknown');
    const [accepted, setAccepted] = useState(false);
    const { dispatchNotification } = useNotification();

    useEnterpriseGPTApiCall(async (client, abortSignal) => {
        try {
            await client.isUserEnrolled(abortSignal);
            setEnrollementState('enrolled');
        } catch (e: unknown) {
            setEnrollementState('not-enrolled');
            dispatchNotification('error.api.get.enrollment', 'error');
        }
    });

    const handleUserConsentToTermsOfUse = () => {
        return performEnterpriseGPTApiCall(async (client, cancelToken) => {
            try {
                await client.enroll(cancelToken);
                setAccepted(true);
                setEnrollementState('enrolled');
            } catch {
                setAccepted(false);
                dispatchNotification('error.api.post.enrollment', 'error');
            }
        });
    };

    // If the user is already enrolled, we render the application, otherwise we show the enrollment dialog
    if (accepted) {
        return <>{children}</>;
    } else {
        return <EnrollmentDialog open={true} onAccept={handleUserConsentToTermsOfUse} />;
    }
};

export default EnrollmentChecker;
